import React, { useCallback, useEffect, useState } from "react";
import { Box, Fade } from "@mui/material";
import Iconify from "./Iconify";
import { ctaGlowSx, EASE_OUT } from "../theme/brand";

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Fade in={visible}>
      <Box
        component="button"
        type="button"
        onClick={scrollToTop}
        aria-label="Nach oben scrollen"
        sx={{
          position: "fixed",
          right: { xs: 16, md: 28 },
          bottom: { xs: 16, md: 28 },
          zIndex: 20,
          width: 46,
          height: 46,
          borderRadius: "50%",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          ...ctaGlowSx,
          transition: `${ctaGlowSx.transition}, transform 160ms ${EASE_OUT}`,
          "&:hover": {
            ...ctaGlowSx["&:hover"],
            transform: "translateY(-2px)",
          },
          "&:active": { transform: "scale(0.92)" },
        }}
      >
        <Iconify icon="mdi:arrow-up" width={22} sx={{ color: "#fff" }} />
      </Box>
    </Fade>
  );
}
